import styled from 'styled-components';

export const HeaderAtendi = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  .button {
    margin: 10px;
  }
`;

export const RowLine = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: wrap;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 15px;
  padding: 5px 0;
`;

export const LabelRow = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 10px;
  color: #595959;
  margin-bottom: 5px;
`;

export const SpanBlock = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.85);
`;
